import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { ObserveDetails } from '../Models/ObserveDetails';
import { Observation } from '../Models/Observation';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PhBhpSelectCategoryComponent } from '../ph-bhp-select-category/ph-bhp-select-category.component';
import { PhBhpFrequentCategoryComponent } from '../ph-bhp-frequent-category/ph-bhp-frequent-category.component';
import { PHBHPFeaturePackageObserveObservationService } from '../ph-bhp-feature-package-observe-observation.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { fiveMomentsMap } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-asepticprocedures.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-ph-bhp-observation-protocol-feedback',
  templateUrl: './ph-bhp-observation-protocol-feedback.component.html',
  styleUrls: ['./ph-bhp-observation-protocol-feedback.component.css']
})
export class PhBhpObservationProtocolFeedbackComponent implements OnInit {
  modalRef1: BsModalRef;
  activeIndex = 0;
  showindication : boolean = false;
  showcategory: boolean = true;
  selectedward;
  selecteddept;
  sessionName;
  endDateTime;
  startDateTime;
  totalNumberOfObservations = 0;
  observeDetails:any = [];
  @Input() sessionId;
  @Input() userId;
  @Input() institutionId;
  @Input() countryId;
  @ViewChild('chart') chart;
  selectedcategory;
  selectedsubcategory;
  totalQuota;
  quotaStartDateTime;
  quotaEndDateTime;
  quotaDaysLeft;  
  observedQuota;
  numberOfDays;
  quotaId;
  activecomments = 0;
  activemoments = 0;
  numberOfObservations = 0;
  positveCompliance = 0;
  observeRightTab;
  observations:Array<Observation>;
  fiveMomentsMap: any[];
  tempCompliances = {
    beforeTouchingAPatient :0, 
    beforeCleanAsepticProcedures :0, 
    afterBodyFluidExposureRisk :0, 
    afterTouchingAPatient :0, 
    afterTouchingPatientSurrandings:0
  }
  translationKeys: typeof TranslationKeys = TranslationKeys;
  
  constructor(private modalService: BsModalService,public modalRef: BsModalRef,private service: PHBHPFeaturePackageObserveObservationService, private layoutService: PHBHPLayoutPackageService,public translate: TranslateService) {
    this.fiveMomentsMap = fiveMomentsMap;
   }

  ngOnInit() {
    this.showindication=true;
    this.getUserSessionDetail();
    // this.fiveMomentsMap.forEach(el => el.short = this.data.translatetext(el.short));
    this.layoutService.lang.asObservable().subscribe((changelang) => {
      // this.fiveMomentsMap.forEach(el => el.short = this.data.translatetext(el.short));
    })
    
  }
  getUserSessionDetail(){
    this.layoutService.showLoader = true;
    this.service.getUserSessionDetail(this.userId,this.institutionId, this.sessionId, this.countryId, this.translate.currentLang).subscribe((res: Array<ObserveDetails>)=>{
      this.layoutService.showLoader = false;
      this.observeDetails = res[0];
      this.selectedward= this.observeDetails.wardName;
      this.selecteddept= this.observeDetails.departmentName;
      this.sessionName = this.observeDetails.sessionName;
      this.totalNumberOfObservations = this.observeDetails.numberOfObservations;
      this.startDateTime = this.observeDetails.startDateTime;
      this.endDateTime = this.observeDetails.endDateTime;
      this.totalQuota = this.observeDetails.totalQuota;
      this.quotaStartDateTime = this.observeDetails.quotaStartDateTime;
      this.quotaEndDateTime = this.observeDetails.quotaEndDateTime;
      this.quotaDaysLeft = this.observeDetails.quotaDaysLeft;  
      this.observedQuota = this.observeDetails.observedQuota;
      this.quotaId = this.observeDetails.quotaId;
      this.numberOfDays = this.observeDetails.numberOfDays;
      this.setObserveCategory(0)
      
    })
  }
  openCancelModal(cancelmodal: TemplateRef<any>) {
    this.modalRef1 = this.modalService.show(cancelmodal, Object.assign({}, { class: 'w-420' })
    )
  }

  getSession(index) {
    this.observeRightTab = true;  
    this.setObserveCategory(index)
  }
  getCategoryName(name) {
    let text = '';
    if(name){
      let arr = name.split(' ');
      for (let i = 0; i < arr.length; i++) {
        text += arr[i].substr(0, 1)
      }
    }
    return text.toUpperCase();
  }
  fiveMomentsUsingKeys(shortName,key){
    if(shortName != 0)
      return this.fiveMomentsMap.find(res=>this.layoutService.translateText(res[key]) == shortName);
    return null;
  }
  setObserveCategory(index){
    this.activeIndex = index;
    this.selectedcategory= this.observeDetails.observeCategorys[index].professsionalCategoryName;
    this.selectedsubcategory= this.observeDetails.observeCategorys[index].professionalSubCategoryName;
    this.observations= this.observeDetails.observeCategorys[index].observations;
    this.numberOfObservations= this.observeDetails.observeCategorys[index].numberOfObservations;
    this.positveCompliance= this.observeDetails.observeCategorys[index].positveCompliance;    
    var positiveCompliances = this.observeDetails.observeCompliances[index].positiveMovement;
    if(positiveCompliances == null){
      positiveCompliances = this.tempCompliances
    }
    var negativeCompliances = this.observeDetails.observeCompliances[index].negativeMovement;
    if(negativeCompliances == null){
      negativeCompliances = this.tempCompliances
    }
    let positBefTouPat =  positiveCompliances.beforeTouchingAPatient;
    let positBefAsep = positiveCompliances.beforeCleanAsepticProcedures;
    let positAfterBody = positiveCompliances.afterBodyFluidExposureRisk;
    let positAftTouPat = positiveCompliances.afterTouchingAPatient;
    let positPatSorr = positiveCompliances.afterTouchingPatientSurrandings;
    let totalBefTouPat = positBefTouPat + negativeCompliances.beforeTouchingAPatient;
    let totalBefAsep = positBefAsep + negativeCompliances.beforeCleanAsepticProcedures;
    let totalAfterBody = positAfterBody + negativeCompliances.afterBodyFluidExposureRisk;
    let totalAftTouPat = positAftTouPat + negativeCompliances.afterTouchingAPatient;
    let totalPatSorr =  positPatSorr + negativeCompliances.afterTouchingPatientSurrandings;
    this.chart.chartOptions.series= [{
      data: [
        Math.round((positBefTouPat/totalBefTouPat)*100), 
        Math.round((positBefAsep/totalBefAsep)*100), 
        Math.round((positAfterBody/totalAfterBody)*100), 
        Math.round((positAftTouPat/totalAftTouPat)*100),
        Math.round((positPatSorr/totalPatSorr)*100)
      ],
      color: "#001689",
      labels: {
        font: "9px OpenSans-Regular"
      }
    },
    ];
    this.chart.chartOptions.seriesDefaults= {
      type: "bar",
      stack: false
    };
  
    this.chart.chartOptions.categoryAxis.categories=  [
      this.layoutService.translateText(fiveMomentsMap[0].abbr),
      this.layoutService.translateText(fiveMomentsMap[1].abbr),
      this.layoutService.translateText(fiveMomentsMap[2].abbr),
      this.layoutService.translateText(fiveMomentsMap[3].abbr),
      this.layoutService.translateText(fiveMomentsMap[4].abbr),
    ];
    this.chart.noDataFound = false;
    this.chart.chartDatamani();
    this.chart.findTooltipText = (truncatedText)=> {
      const translateTruncated = this.layoutService.translateText(truncatedText);
      const tooltip = this.fiveMomentsUsingKeys(translateTruncated, 'abbr')
          ? this.layoutService.translateText(this.fiveMomentsUsingKeys(translateTruncated, 'abbr').name) : '';
      return tooltip;
    }
  }
  

  

}
